var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMotor(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 25,
    viewBox: "0 0 37 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 5.74121H1.07655V20.9997H0V5.74121Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.7758 0.5H22.1895V1.57655H10.7758V0.5Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M34.2086 4.22754H31.4738V22.5221H34.2086C35.2374 22.5207 36.0694 21.6887 36.0709 20.6598V6.08997C36.0694 5.06261 35.2374 4.22898 34.2086 4.22754Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M25.6323 6.87904L22.239 2.24121H10.7019L5.70251 5.57511V21.1666L10.7034 24.5005H22.239L25.6323 19.8616C25.6988 19.7704 25.8074 19.7155 25.9217 19.7155H30.7577L30.7562 7.02664H25.9217C25.8074 7.02664 25.6988 6.97164 25.6323 6.87904ZM21.689 18.3854H9.57621C9.37797 18.3854 9.2159 18.2248 9.2159 18.0266C9.2159 17.8283 9.37797 17.6677 9.57621 17.6677H21.689C21.8872 17.6677 22.0479 17.8283 22.0479 18.0266C22.0479 18.2248 21.8872 18.3854 21.689 18.3854ZM21.689 13.7291H9.57621C9.37797 13.7291 9.2159 13.5685 9.2159 13.3702C9.2159 13.172 9.37797 13.0114 9.57621 13.0114H21.689C21.8872 13.0114 22.0479 13.172 22.0479 13.3702C22.0479 13.5685 21.8872 13.7291 21.689 13.7291ZM21.689 9.07274L9.57621 9.07419C9.37797 9.07419 9.2159 8.91212 9.2159 8.71388C9.2159 8.51709 9.37797 8.35502 9.57621 8.35502H21.689C21.8872 8.35502 22.0479 8.51709 22.0479 8.71388C22.0479 8.91212 21.8872 9.07419 21.689 9.07419V9.07274Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M1.81604 5.74121H4.98499V20.9986H1.81604V5.74121Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMotor);
export default __webpack_public_path__ + "static/media/Motor.3b4f6e188b8599cc49546398db452c22.svg";
export { ForwardRef as ReactComponent };